import type { ItineraryProduct } from '@/types/products';

export function getMainContentItineraryProduct(itineraryProduct: ItineraryProduct) {
  return itineraryProduct.Content?.filter((content) => content.type.toLowerCase() === 'main')[0];
}

export function getRoomTypesAccommodationProduct(itineraryProduct: ItineraryProduct) {
  const roomTypes: string[] = [];

  roomTypes.push(itineraryProduct.nameForClient || '');

  itineraryProduct.alternate?.forEach((room) => {
    if (!roomTypes.includes(room.name)) {
      roomTypes.push(room.name);
    }
  });

  return roomTypes;
}
